<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormCorreoCliente" role="form" method="post" autocomplete="off" onSubmit="return false">
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Correo">Correo</label>
							<input type="text" v-model="objCorreoCliente.Correo" class="form-control" id="Correo" placeholder="Ingresar Correo" />
							<CValidation v-if="this.errorvalidacion.Correo" :Mensaje="'*'+errorvalidacion.Correo[0]"/>
						</div>
					</div>
											
					<br>
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormCorreoCliente',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCorreoCliente: {
				IdCorreoCliente: 0,
				IdCliente: 0,
				Correo: '',
				Tipo: 'CC',
                RegEstatus: 'A'
				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
			this.poBtnSave.Toast = 0; 
			this.poBtnSave.DisableBtn = true;

			if(this.objCorreoCliente.IdCorreoCliente == 0) {
				await this.$http.post(
					'correosClientes',this.objCorreoCliente
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'correosClientes/'+this.objCorreoCliente.IdCorreoCliente,
					this.objCorreoCliente
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "correosClientes/"+this.objCorreoCliente.IdCorreoCliente
            ).then((res) => {
                this.objCorreoCliente = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objCorreoCliente.Fecha.replace(/-/g,'\/');
                this.objCorreoCliente.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCorreoCliente = {
				IdCorreoCliente: 0,
				IdCliente: 0,
				Correo: '',
				Tipo: 'CC',
				RegEstatus: 'A',
				
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();

			let ObjCliente = JSON.parse(sessionStorage.getItem('objCliente'));
			this.objCorreoCliente.IdCliente = ObjCliente.IdCliente;
                
            if (Id!='') 
            {
                this.objCorreoCliente.IdCorreoCliente = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
